export const ActivityLogActionTypes = {
    API_RESPONSE_SUCCESS: '@@activity-log/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@activity-log/API_RESPONSE_ERROR',
    GET_LOG_ENTRIES: '@@activity-log/GET_LOG_ENTRIES',
    RESET_STATE: '@@activity-log/RESET_STATE',
};
